import { Box, Stack, Typography } from '@mui/material';

import PonduranceLogoFull from '@/assets/pondurance-horizontal-full-black.png';
import CoverImage from '@/assets/report-cover-silhouette.png';
import CoverWaveImage from '@/assets/report-cover-wave.png';

import { formatDateRange } from '../ReportsTemplate.utils.tsx';
import type { CoverProps } from './ReportsPage.types.ts';

const ReportsPageCover = ({
  reportName,
  organizationName,
  reportFrequency
}: CoverProps) => {
  return (
    <Box
      data-testid="reports-page-cover"
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        overflow: 'hidden',
        padding: '20mm 0mm 30mm 105mm'
      }}
    >
      {/* Background Wave Image */}
      <Box
        component="img"
        src={CoverWaveImage}
        alt="Cover Wave"
        sx={{
          position: 'absolute',
          bottom: -120,
          left: -90,
          width: '120%',
          zIndex: 0,
          objectFit: 'contain'
        }}
      />

      {/* Background Silhouette Image */}
      <Box
        component="img"
        src={CoverImage}
        alt="Cover Figure"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: -20,
          height: '70%',
          zIndex: 0,
          objectFit: 'contain',
          transform: 'scaleX(-1)'
        }}
      />

      {/* Text Content - aligned right */}
      <Box sx={{ position: 'relative', zIndex: 2, maxWidth: '100%' }}>
        <Stack spacing={1}>
          <img
            src={PonduranceLogoFull}
            alt="Pondurance"
            style={{ width: '70%', left: -20 }}
          />

          {/* Box Line to separate content */}
          <Box
            sx={{
              backgroundColor: '#D1E2D5',
              height: '4px',
              width: '100%'
            }}
          />

          <Typography
            variant="h1"
            sx={{ fontWeight: 'bold', color: '#1C4A50', paddingTop: '40px' }}
          >
            {reportName}
          </Typography>
          <Typography
            variant="h3"
            sx={{ color: '#1C4A50', paddingTop: '10px' }}
          >
            {organizationName}
          </Typography>
          <Typography variant="h4" sx={{ color: '#4A8086' }}>
            {formatDateRange(reportFrequency)}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default ReportsPageCover;
